
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/c/[cat]",
      function () {
        return require("private-next-pages/projects/c/[cat].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/c/[cat]"])
      });
    }
  